import { useEffect, useMemo, useState } from 'react';
import { applyColors, CropCircleColorsMap, LegacyColors } from './colors';

let themeVersion = 0;
const listeners = new Set<() => void>();

export function setUseCropCircleDesign(enabled: boolean) {
  applyColors(enabled ? CropCircleColorsMap : LegacyColors);
  themeVersion++;
  listeners.forEach((l) => l());
}

export function subscribeToThemeChanges(cb: () => void) {
  listeners.add(cb);
  return () => {
    listeners.delete(cb);
  };
}

export function useThemedStyles<T>(styleCreator: () => T): T {
  const [version, setVersion] = useState(themeVersion);

  useEffect(() => {
    return subscribeToThemeChanges(() => {
      setVersion(themeVersion);
    });
  }, []);

  // version is intentionally included to trigger re-creation when theme changes
  // eslint-disable-next-line react-hooks/exhaustive-deps
  return useMemo(() => styleCreator(), [version, styleCreator]);
}
